import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bxs-bell.svg")